import React, { useState } from "react";
import { Configurations } from "../../Utils/Configurations";
//import './Cile-Content.scss';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import ImagemFukyo from "../../Components/Imagem-Fukyo/Imagem-Fukyo";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";

const BannerDetails = (props) => {

    const [loading, setLoading] = useState(false)
    const [formState, setFormState] = useState(props.location.state ? {
        imageDesk: props.location.state.item.imageDesk,
        imageMobile: props.location.state.item.imageMobile,
        link: props.location.state.item.link,
        ativo: props.location.state.item.ativo,
        idItem: props.location.state.item.idItem
    } : {
        imageDesk: '',
        imageMobile: '',
        link: ''
    })

    const [image, setImage] = useState()
    const [imageName, setImageName] = useState()
    const [temArquivo, setTemArquivo] = useState(false)
    const [loadingSalvar, setLoadingSalvar] = useState(false)
    const [modalUpload, setModalUpload] = useState(false)
    const [uploadDesk, setUploadDesk] = useState()
    const [tipoImagem, setTipoImagem] = useState()
    const [mensagemSalvar, setMensagemSalvar] = useState(false)

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        setMensagemSalvar(true);
    };

    const handleImageChange = (e) => {
        const { value } = e.target;
        setImageName(value)
    };

    const EditarBanner = () => {
        const config = new Configurations();

        axios.put(config.apiBasePath + `/destaques/banners`, formState)
            .then(() => {
                setLoading(true)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                window.history.go(-1)
            )
    }

    const AdicionarBanner = () => {
        const config = new Configurations();
        const _body = {
            "imageDesk": formState.imageDesk,
            "imageMobile": formState.imageMobile,
            "link": formState.link
        };

        axios.post(config.apiBasePath + `/destaques/banners/novo`, _body)
            .then(() => {
                setLoading(true)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                window.history.go(-1)
            )
    }



    const onSelectFileImage = (e) => {
        setImage(e.target.files[0])
        setTemArquivo(true)
    }

    const salvarImg = async () => {
        const config = new Configurations();
        var bodyFormData = new FormData();
        bodyFormData.append('imagem', image);
        bodyFormData.append('tipo', 'banners');
        bodyFormData.append('nomeImagem', imageName);

        setLoadingSalvar(true)

        await axios.post(config.apiBasePath + `/hub/imagem/upload`, bodyFormData).then(response => {

            setFormState((prevState) => ({
                ...prevState,
                [tipoImagem]: response.data.image,
            }));
            setLoadingSalvar(false)
            setModalUpload(false)
            setImageName()
            setMensagemSalvar(true);
        }).catch(err => {
            console.log("ERROR:", err)
            setLoadingSalvar(false)
        })
            .finally(() =>
                setTemArquivo(false)
            );
    }

    const podeSalvar = () => {

        const urlValida = !!formState.link && formState.link.trim() !== "";

        const imagemDeskValida = !!formState.imageDesk && formState.imageDesk.trim() !== "";

        const imagemMobileValida = !!formState.imageMobile && formState.imageMobile.trim() !== "";

        const fluxoEdicao = !!props.location.state;

        if (fluxoEdicao) {
            if (temArquivo) {
                return !urlValida || !imagemDeskValida || imagemMobileValida
            }
            else {
                return !urlValida
            }
        } else {
            return !urlValida || !imagemDeskValida || !imagemMobileValida
        }
    }

    const podeSalvarImg = () => {
        const nomeImgValido = !!imageName && imageName.trim() !== '';
        const fluxoEdicao = !!props.location.state;

        if (fluxoEdicao) {
            if (temArquivo) {
                return !nomeImgValido
            }
        } else {
            return !nomeImgValido || !temArquivo
        }
    }

    const toggleModal = (e) => {
        setModalUpload(!modalUpload)
        setUploadDesk(e)
    }


    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-8 text-center text-lg-left">
                            {props.location.state ?
                                <h2 className="title-1 d-none d-lg-block">Editar Banner</h2>
                                :
                                <h2 className="title-1 d-none d-lg-block">Adicionar Banner</h2>
                            }
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters px-3">
                    {props.location.state && mensagemSalvar ?
                        <div className="col-12 text-center pt-4">
                            <div className="card bg-warning py-4">
                                <h5 className="m-0">As alterações só serão registradas após clicar no botão SALVAR ALTERAÇÕES.</h5>
                            </div>
                        </div> 
                    : ''}

                    <div className={'py-3 col-12'}>
                        <label className="pl-2"><strong>Redirecionar para:</strong></label>
                        <p className="pl-2" style={{ fontSize: '14px' }}>Inserir link completo</p>
                        <input name="link" type="text" className="form-control" autoComplete="off" defaultValue={props.location.state ? formState.link : ''} value={formState.link} onChange={handleInputChange} required={true} />


                        <div className="row">

                            <div className="col-6 my-3 text-center">
                                <button className="btn btn-outline-info" onClick={() => toggleModal(true) + setTipoImagem('imageDesk')}>Imagem Desktop</button>

                                <ImagemFukyo
                                    className={`img img-fluid pt-3 px-5 w-100`}
                                    src={formState.imageDesk}
                                    alt={`imagem-destaque`}
                                />
                            </div>


                            <div className="col-6 my-3 text-center">
                                <button className="btn btn-outline-info" onClick={() => toggleModal(false) + setTipoImagem('imageMobile')}>Imagem Mobile</button>

                                <ImagemFukyo
                                    className={`img img-fluid pt-3 px-5 w-100`}
                                    src={formState.imageMobile}
                                    alt={`imagem-destaque`}
                                />
                            </div>
                        </div>

                    </div>
                    <div className='col-12 text-right py-2'>
                        {loading ? <div className="spinner-border text-success" role="status" />
                            :
                            <button className='btn btn-outline-success'
                                onClick={() => props.location.state ? EditarBanner() : AdicionarBanner()} disabled={podeSalvar()} >
                                {props.location.state ? 'Salvar alterações' : 'Adicionar banner'}
                            </button>
                        }

                        {/* {loading ? <div className="spinner-border text-success" role="status" />
                            :
                            <button className='btn btn-outline-success' disabled={podeSalvar()}
                                onClick={() => props.location.state ? EditarBanner() : AdicionarBanner()} >
                                {props.location.state ? 'Salvar' : 'Incluir banner'}
                            </button>
                        } */}

                    </div>

                </div>



            </div>

            <Modal isOpen={modalUpload} toggle={toggleModal} >
                <ModalHeader toggle={toggleModal}>Adicionar imagem para {uploadDesk ? "desktop" : "mobile"}</ModalHeader>
                <ModalBody>
                    <label className="pl-2 pt-3"><strong>Título da imagem para {uploadDesk ? "desktop" : "mobile"}:</strong></label>
                    <ul>
                        <li className="pl-2 m-0" style={{ fontSize: '14px' }}>Usar traço (-) para fazer a separação das palavras</li>
                    </ul>

                    <p className="pl-2" style={{ fontSize: '14px' }}>Exemplo: banner-liga-monarca-desktop</p>
                    <input name="url" type="text" className="form-control" autoComplete="off" value={imageName} onChange={handleImageChange} required={true} />

                    <label className="pl-2 pt-3"><strong>Imagem:</strong></label>
                    <br />
                    <input type="file" accept=".jpg,.jpeg,.png" className="pb-3" onChange={onSelectFileImage} />
                </ModalBody>
                <ModalFooter>
                    {loadingSalvar ? (
                        <div className="spinner-border text-primary" role="status" />
                    ) : (
                        <Button disabled={podeSalvarImg()} color={`success`} onClick={() => salvarImg()}>Salvar</Button>
                    )}
                </ModalFooter>
            </Modal>
        </div>
    )
}



export default withRouter(BannerDetails);